import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, reactive, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  isOpen: {
    type: Boolean,
    required: true
  },
  title: {
    type: String,
    required: true
  },
  message: {
    type: String,
    required: true
  },
  buttonValidateMessage: {
    type: String,
    required: true
  },
  email: {
    type: String,
    required: true
  }
},
  emits: ["cancel", "validate"],
  setup(__props, { emit }) {

const props = __props




const state = reactive({
  isOpen: computed(() => props.isOpen),
  email: props.email
});

// Ajouter un watcher pour mettre à jour l'email quand la prop change
watch(() => props.email, (newEmail) => {
  state.email = newEmail;
});

return (_ctx: any,_cache: any) => {
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_modal = _resolveComponent("va-modal")!

  return (_openBlock(), _createBlock(_component_va_modal, {
    modelValue: _unref(state).isOpen,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_unref(state).isOpen = $event)),
    "hide-default-actions": "",
    title: props.title,
    message: props.message
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_va_button, {
        flat: "",
        outline: "",
        class: "mr-1",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('cancel')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("buttons.cancel")), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_va_button, {
        class: "ml-1",
        color: "success",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('validate', _unref(state).email)))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.buttonValidateMessage ?? _ctx.$t("buttons.validate")), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_va_input, {
        modelValue: _unref(state).email,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_unref(state).email = $event)),
        label: _ctx.$t('users.email'),
        class: "input-email",
        type: "email"
      }, null, 8, ["modelValue", "label"])
    ]),
    _: 1
  }, 8, ["modelValue", "title", "message"]))
}
}

})